import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { BaseRules, TextValues } from './vermont.model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-vermont',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './vermont.component.html',
  styleUrl: './vermont.component.scss',
})
export class VermontComponent extends UimuiBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('vermont', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('vermont', null);
    }
  }
}
